import { makeStyles } from '@material-ui/core';

export const useDashboardCardStyles = makeStyles({
  paperCards: {
    paddingTop: 0,
    paddingBottom: 0,
    paddingLeft: 0,
    paddingRight: 0,
    boxShadow: '0px 3px 4px #E2E2E2',
    minHeight: 85,
    borderRadius: 2,
  },
  dashboardCard: {
    backgroundColor: 'white',
    padding: 10,
  },
  dashboardCardTitleWhite: {
    fontWeight: 500,
    fontSize: 14,
    color: '#FFFFFF',
    textOverflow: 'ellipsis',
    overflow: 'hidden',
    wordWrap: 'break-word',
    textTransform: 'capitalize',
  },
  dashboardCardTitleDark: {
    fontWeight: 500,
    fontSize: 14,
    color: '#292F36',
    textOverflow: 'ellipsis',
    overflow: 'hidden',
    wordWrap: 'break-word',
    textTransform: 'capitalize',
  },
  dashboardCardTitleWhiteNoHover: {
    margin: '0px 0px 0px 8px',
    fontWeight: 500,
    fontSize: 14,
    color: '#FFFFFF',
    textOverflow: 'ellipsis',
    overflow: 'hidden',
    cursor: 'pointer',
  },
  dashboardCardTitleDarkNoHover: {
    margin: '0px 0px 0px 8px',
    fontWeight: 500,
    fontSize: 14,
    color: '#292F36',
    textOverflow: 'ellipsis',
    overflow: 'hidden',
    cursor: 'pointer',
  },
  dashboardCardValueDark: {
    paddingLeft: 12,
    paddingRight: 2,
    textAlign: 'left',
    fontSize: 24,
    color: '#292F36',
    fontWeight: 600,
  },
  dashboardCardSuffixDark: {
    fontSize: 24,
    paddingBottom: 5,
    color: '#292F36',
    fontWeight: 700,
  },
  dashboardCardValueWhite: {
    paddingLeft: 12,
    paddingRight: 2,
    textAlign: 'left',
    fontSize: 24,
    color: '#FFFFFF',
    fontWeight: 600,
  },
  dashboardCardSuffixWhite: {
    fontSize: 24,
    paddingBottom: 5,
    color: '#FFFFFF',
    fontWeight: 700,
  },
  dashboardCardValueSmallWhite: {
    padding: '4px 12px',
    fontWeight: 400,
    textAlign: 'left',
    fontSize: 12,
    color: '#FFFFFF',
  },
  dashboardCardValueSmallDark: {
    padding: '4px 12px',
    fontWeight: 400,
    textAlign: 'left',
    fontSize: 12,
    color: '#292F36',
  },
  dashboardCardComparePositive: {
    padding: '4px 6px',
    fontWeight: 500,
    textAlign: 'left',
    fontSize: 12,
    color: '#00B7A9',
  },
  dashboardCardCompareNegative: {
    padding: '4px 6px',
    fontWeight: 500,
    textAlign: 'left',
    fontSize: 12,
    color: '#F03827',
  },
  menuRoot: {
    backgroundColor: '#FFFFFF',
    boxShadow: '0px 3px 4px #e2e2e2',
  },
  dashboardCardText: {
    fontSize: 11,
    color: '#292F36',
  },
  dashboardTitleCard: {
    boxShadow: 'none',
    marginLeft: '4px',
    marginTop: '3px',
  },
  dashboardTitleText: {
    marginLeft: '8px',
    marginTop: '3px',
  },
  arrowDown: {
    transform: 'rotate(180deg)',
  },
});
